import { Text } from '@react-email/components';

import React from 'react';

const Message = ({ children , style }) => {
    return (
        <Text
            style={{
                textAlign: 'center',
                fontFamily: 'Poppins',
                fontSize: '16px',
                fontWeight: 500,
                color:'#75BD2F',
                ...style
            }}
        >
            {children}
        </Text>
    );
};

export default Message;
